// extracted by mini-css-extract-plugin
export default {"text":"dateformat_text__lmYBe"};